"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var e=t(require("styled-components")).default.section`
  height: 0;
  padding-top: 70%;
  position: relative;
  overflow: hidden;
  background: ${({theme:t})=>t.colors.grey[5]};

  picture {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    z-index: -1;
    opacity: 0;

    &.prev {
      opacity: 1;
      z-index: 2;
      animation: prev_image
        ${({direction:t})=>"left"===t?"0s":".4s"} ease-in-out
        forwards;

      &.instant {
        animation-duration: 0s;
      }
    }

    &.active {
      opacity: 1;
      z-index: 3;
      animation: ${({direction:t})=>`active_image_${t}`} 0.4s
        ease-in-out forwards;
    }

    &.next {
      opacity: 1;
      z-index: 2;
      animation: next_image
        ${({direction:t})=>"right"===t?"0s":".4s"} ease-in-out
        forwards;
    }

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }

  @keyframes prev_image {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  @keyframes next_image {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(100%);
    }
  }

  @keyframes active_image_right {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0);
    }
  }

  @keyframes active_image_left {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
